import React from "react";
import { toastr } from "react-redux-toastr";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { FormGroup, FormControl, FormLabel } from "react-bootstrap";
import { FiCalendar, FiX } from "react-icons/fi";
import { employeesService } from "services";
import { errorFormating } from "utils/utils";
import SubmitButton from "components/SubmitButton";
import InlineAlert from "components/InlineAlert";
import EmployeeSelectSearch from "components/EmployeeSelectSearch/EmployeeSelectSearch";

import DatePicker, { registerLocale } from "react-datepicker";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import es from "date-fns/locale/es"; // datepicker locale
registerLocale("es", es);

class ContractEmployeeEdit extends React.Component {
	constructor(props) {
		super(props);

		// console.log(props);
		const { contract } = this.props;

		let contract_employee = {
			contract_id: contract.id,
			start_day: "",
		};

		let isEdit = false;

		if (props.contract_employee) {
			contract_employee = {
				...props.contract_employee,
				contract_id: props.contract_employee.contract.id,
			};
			isEdit = true;
		}

		this.state = {
			isEdit,
			isLoading: false,
			submitted: false,
			errors: {},
			contract_employee,
			selected_employee_ids: [],
			new_employee_id: "",
			new_employee_candidate: null,
		};
	}

	employeeSelectFetchOptions = { active: true };

	handleChange = (event) => {
		const { contract_employee } = this.state;

		this.setState({
			contract_employee: {
				...contract_employee,
				[event.target.id]: event.target.value,
			},
		});
	};

	handleAddChange = (idOrNull, employee) => {
		this.setState({
			new_employee_id: idOrNull || "",
			new_employee_candidate: employee || null,
		});
	};

	handleDateChange = (id, date) => {
		const { contract_employee } = this.state;

		let key = id;
		let value = date ? moment(date).format("YYYY-MM-DD") : null;

		this.setState({
			contract_employee: {
				...contract_employee,
				[key]: value,
			},
		});
	};

	checkValidField = (name) => {
		return (
			this.state.submitted &&
			this.state.errors[name] !== undefined &&
			this.state.errors[name] !== ""
		);
	};

	addSelectedEmployee = () => {
		let { selected_employee_ids, new_employee_id, new_employee_candidate } = this.state;
		let isValid = true;
		let employee;
		const errors = {};

		if (new_employee_id === undefined) {
			isValid = false;
		}
		else {
			employee = new_employee_candidate;
			if (employee === undefined || employee === null) {
				isValid = false;
				errors.employee = false;
			}
		}

		if (isValid) {
			// check if employee already exists
			const exists = selected_employee_ids.find(item => item.id === parseInt(new_employee_id));

			if (!exists) {
				selected_employee_ids = selected_employee_ids.concat(employee);
			}

			this.setState({
				selected_employee_ids,
				errors: {},
				new_employee_id: "",
				new_employee_candidate: null,
			});
		}
		else {
			this.setState({
				errors,
			});
		}
	}

	removeSelectedEmployee = (idEmployee) => {
		this.setState((prevState, props) => ({
			selected_employee_ids: prevState.selected_employee_ids.filter(item => item.id !== parseInt(idEmployee))
		}));
	}

	getSelectedEmployees = () => this.state.selected_employee_ids.length > 0 && this.state.selected_employee_ids.map((item) => {
		return (
			<li key={item.id} aria-label={item.description} title={item.description} className="tag-default tag-delete" style={{ backgroundColor: item.background_color && item.background_color }}>
				{`${item.name} ${item.surname}`}
				<button type="button" onClick={() => this.removeSelectedEmployee(item.id)} className="btn-tag-delete btn-transparent"><FiX /></button>
			</li>
		)
	});


	handleSubmit = async (event) => {
		event.preventDefault();

		this.setState({ isLoading: true, submitted: true });

		const props = this.props;
		const { isEdit, contract_employee, selected_employee_ids } = this.state;

		if (isEdit) {
			// Editar un solo empleado
			const response = await employeesService.updateContract(
				contract_employee.employee_id,
				contract_employee
			);

			if (response.ok) {
				this.setState({ isLoading: false, errors: {} }, () => {
					toastr.success(this.props.t("common.success"), this.props.t("common.changesSaved"));
					// TODO revisar props.getContractEmployees();
					props.handleClose();
				});
			} else {
				this.setState({
					isLoading: false,
					// errors: errorFormating(response),
					errors: errorFormating(response, { includeFieldsInGeneral: false })
				});
			}
		} else {

			// Validar que haya empleados seleccionados
			if (selected_employee_ids.length === 0) {
				this.setState({
					isLoading: false,
					errors: {
						employees_ids: this.props.t("contracts.assignment.noEmployeeSelected"),
					},
				});
				return;
			}

			// Añadir varios empleados
			const errors = [];
			let successful = 0;

			for (const emp of selected_employee_ids) {
				const newData = {
					...contract_employee,
					employee_id: emp.id,
				};

				const res = await employeesService.addContract(emp.id, newData);

				if (!res.ok) {
					// const formatted = errorFormating(res);
					const formatted = errorFormating(res, { includeFieldsInGeneral: false });
					const joined = Object.values(formatted).join(", ");
					errors.push(`${emp.name} ${emp.surname}: ${joined}`);
				} else {
					successful++;
				}
			}

			this.setState({ isLoading: false });

			if (errors.length === 0) {
				const successMsg = selected_employee_ids.length === 1
					? this.props.t("contracts.assignment.employeeAdded")
					: this.props.t("contracts.assignment.employeesAdded");

				toastr.success("¡Bien!", successMsg);
				props.getContracts();
				props.handleClose();
			} else {
				this.setState({
					errors: {
						generalList: errors,
					},
				});

				if (successful > 0) {
					props.getContracts();
				}
			}
		}
	};



	render() {
		const { contract } = this.props;
		const { contract_employee, errors, isEdit, new_employee_id } = this.state;

		return (
			<form onSubmit={this.handleSubmit}>
				<div className="modal-body">
					<FormGroup className="form-group" controlId="employee_id">
						<FormLabel>{this.props.t("contracts.assignment.contract")}</FormLabel>
						<FormControl
							value={contract.name}
							disabled={true}
						/>
					</FormGroup>
					{isEdit ? (
						<FormGroup className="form-group" controlId="employee_id">
							<FormLabel>{this.props.t("contracts.assignment.employee")}</FormLabel>
							<FormControl
								value={contract_employee.employee_id}
								disabled={true}
							/>
						</FormGroup>
					) : (
						<div className="row-adding row-adding-days">
							<div className="flex-group justify-content-between">
								<FormGroup controlId="new_employee_id">
									<FormLabel>{this.props.t("contracts.assignment.employees")} <span className="label-required">*</span></FormLabel>
									<EmployeeSelectSearch
										className="form-select-user"
										controlId="new_employee_id"
										multiple={false}
										value={new_employee_id || null}
										onChange={this.handleAddChange}
										fetchOptions={this.employeeSelectFetchOptions}
										placeholder={this.props.t("contracts.assignment.selectEmployee")}
										allLabel={this.props.t("contracts.assignment.selectEmployee")}
									/>

									{this.checkValidField('employees_ids') && (
										<div className="invalid-feedback d-block">
											{errors.employees_ids}
										</div>
									)}

								</FormGroup>
								<button type="button" onClick={this.addSelectedEmployee} className="btn btn-primary">{this.props.t("common.add")}</button>
							</div>

							<ul className="list-tags">
								{this.getSelectedEmployees()}
							</ul>
						</div>
					)}

					<FormGroup controlId="start_day" className={`form-group form-date ${(contract_employee.start_day === '' || !contract_employee.start_day) && 'empty'}   ${this.checkValidField('start_day') && "is-invalid"}`}>
						<FormLabel>{this.props.t("contracts.assignment.startDate")} <span className="label-required">*</span></FormLabel>
						<DatePicker
							selected={contract_employee.start_day ? moment(contract_employee.start_day).toDate() : null}
							onChange={(date) => this.handleDateChange("start_day", date)}
							className="form-control"
							dateFormat="dd/MM/yyyy"
							placeholderText="dd/mm/aaaa"
							locale="es"
							isInvalid={this.checkValidField("start_day")}
						/>
						<FiCalendar />
						<FormControl.Feedback type="invalid">
							{errors.start_day}
						</FormControl.Feedback>
					</FormGroup>

					<FormGroup controlId="end_day" className={`form-group form-date ${this.checkValidField('end_day') && "is-invalid"}`}>
						<FormLabel>{this.props.t("contracts.assignment.endDate")}</FormLabel>
						<DatePicker
							selected={contract_employee.end_day ? moment(contract_employee.end_day).toDate() : null}
							onChange={(date) => this.handleDateChange("end_day", date)}
							className="form-control"
							dateFormat="dd/MM/yyyy"
							placeholderText="dd/mm/aaaa"
							locale="es"
							isInvalid={this.checkValidField("end_day")}
						/>
						<FiCalendar />
						<FormControl.Feedback type="invalid">
							{errors.end_day}
						</FormControl.Feedback>
					</FormGroup>

					{this.state.errors && this.state.errors.general && (
						<InlineAlert variant="error">
							{this.state.errors.general}
						</InlineAlert>
					)}

					{this.state.errors && this.state.errors.contract_id && (
						<InlineAlert variant="error">
							{this.state.errors.contract_id}
						</InlineAlert>
					)}

					{this.state.errors && this.state.errors.generalList && this.state.errors.generalList.length > 0 && (
						<InlineAlert
							variant="error"
							message={this.props.t("contracts.assignment.saveErrorTitle")}
							details={
								<ul className="inline-alert__list">
									{this.state.errors.generalList.map((err, idx) => (
										<li key={idx}>{err}</li>
									))}
								</ul>
							}
							detailsOpen
						/>
					)}
				</div>

				<div className="modal-footer">
					<button
						type="button"
						onClick={this.props.handleClose}
						className="btn btn-outline-primary"
					>
						{this.props.t("common.cancel")}
					</button>
					<SubmitButton
						type="submit"
						isLoading={this.state.isLoading}
						text={this.props.t("common.save")}
						loadingText={this.props.t("common.saving")}
					/>
				</div>
			</form >
		);
	}
}

const mapStateToProps = (state) => {
	return {
		...state.employeesReducer,
		...state.contractsReducer,
	};
};

export default connect(mapStateToProps)(withTranslation()(ContractEmployeeEdit));

